module.exports = __webpack_public_path__ + "img/sahil-bhasin.d5f3c4b1.png";